//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../Weld/Weld.WeldBeadPathBuilderList.js";
import "../no/ScCollector.js";
import "../Weld/Weld.WeldBeadSizeBuilderList.js";
import "../no/ScCollector.js";
import "../no/ObjectList.js";
let d=[[[0,"BeadLocation",1,0],[0,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"DistanceTolerance",1,0],[0,"ExtendToBoundary",1,0],[0,"FaceInferMethod",1,0],[0,"OutputType",1,0],[1,"PathList",0,"Weld.WeldBeadPathBuilderList",0],[1,"SelectBottomParts",0,"ScCollector",0],[1,"SelectTopParts",0,"ScCollector",0],[1,"SizeList",0,"Weld.WeldBeadSizeBuilderList",0],[0,"TangentAngle",1,0],[0,"TransformSketchToBeadCenterline",1,0],[0,"Type",1,0]],[[[],"NewPath",{R_:{newPathBuilder:"Weld.WeldBeadPathBuilder"}},0,0],[[],"NewSize",{R_:{newSizeBuilder:"Weld.WeldBeadSizeBuilder"}},0,0],[[],"GetPreviewPath",{R_:{previewPathCurve:"Spline"}},0,0],[[],"CreatePreviewPath",{R_:{previewPathCurve:"Spline"}},0,0]],[]];
SPLM.Weld.WeldBeadBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldBeadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldBeadBuilder.Types = Object.freeze({
    "Ellipse" : "Ellipse", "Tube" : "Tube", "Sketch" : "Sketch", "Triangle" : "Triangle", "Rectangle" : "Rectangle"});

SPLM.Weld.WeldBeadBuilder.BeadLocationMethod = Object.freeze({
    "SecondaryParts" : "SecondaryParts", "PrimaryParts" : "PrimaryParts", "InSpace" : "InSpace"});

SPLM.Weld.WeldBeadBuilder.FaceInferMethodType = Object.freeze({
    "TangentFaces" : "TangentFaces", "None" : "None"});

SPLM.Weld.WeldBeadBuilder.OutputTypes = Object.freeze({
    "Fixed" : "Fixed", "Associative" : "Associative"});

export default SPLM;